// fr_pms_personal_dashboard.ts
// Tłumaczenia dla PersonalDashboard.tsx

export const frPmsPersonalDashboard = {

  // ── Powitania ─────────────────────────────────────────────────────────────
  greetings: {
    morning:   "Bonjour",
    afternoon: "Bonjour",
    evening:   "Bonsoir",
  },

  // ── Sekcje widgety ────────────────────────────────────────────────────────
  sections: {
    liveActivity:   "Activite en direct",
    housekeepingQueue:"File housekeeping",
    openIncidents:  "Incidents ouverts",
    handover:       "Transmission",
    finance:        "Finances",
    activity:       "Activite",
    operations:     "Operations",
    maintenance:    "Maintenance",
    guests:         "Clients",
  },

  // ── Pasek narzędzi ────────────────────────────────────────────────────────
  toolbar: {
    customize: "Personnaliser",
    done:      "Termine",
    enter:     "Entrer",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    arrivalToday:           "Arrivee aujourd'hui",
    arrivalsToday:          "Arrivees aujourd'hui",
    assignedToHousekeeping: "Assigne au housekeeping",
    needsCleaning:          "Necessite un nettoyage",
    occupancy:              "Occupation",
    revenue:                "Revenu",
    openIssues:             "Problemes ouverts",
    noCriticalIssues:       "Aucun probleme critique",
    noPickupData:           "Aucune donnee pickup",
    noRevenueData:          "Aucune donnee de revenu",
    noRevenueHistory:       "Aucun historique de revenus",
    noLinkedIncident:       "Aucun incident lie a assigner",
    noLinkedIncidentResolve:"Aucun incident lie a resoudre",
  },

  // ── Przekazanie ───────────────────────────────────────────────────────────
  handover: {
    acknowledged: "Transmission confirmee",
    noteAdded:    "Note de transmission ajoutee",
    markedResolved:"Marque comme resolu",
  },

} as const;

export default frPmsPersonalDashboard;
